"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.jane.description': 'Mujer joven, cálida, suave y amigable.',
};
